import { createBlock } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { getPlaceholderText } from './text';

export type ImageInteractionProps = InteractionProps & {};

const createAssessmentQuestionOption = (props?: {}) => {
  return createBlock(
    'AssessmentQuestionOption',
    [
      createBlock('Text', [], {
        props: {
          content: 'Text example',
        },
      }),
    ],
    {
      props: {},
    }
  );
};

const createAssessmentQuestion = (props?: {}) => {
  return createBlock(
    'AssessmentQuestion',
    [
      createMediaBlock({ child: 1 }),
      createMediaBlock({
        child: 0,
        textPlaceholderContent: getPlaceholderText('h2', 'heading-two'),
        className: 'text-align-center',
      }),
      createBlock(
        'AssessmentQuestionOptions',
        [0, 1, 2, 3].map(option => createAssessmentQuestionOption())
      ),

      createContinueBtn({
        label: 'Submit',
        unlocked: true,
      }),
      createBlock('LearnMore', [], {
        props: {
          location: '',
        },
      }),
    ],
    {
      props: {
        sId: getSId('assessmentQuestion'),
      },
    }
  );
};

export const addAssessmentQuestionOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'AssessmentQuestionOptions') {
    const assessmentOptionBlock = createAssessmentQuestionOption({});

    const contentCardBlockRef = { id: assessmentOptionBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(assessmentOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, contentCardBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeAssessmentQuestionOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'AssessmentQuestionOptions') {
    const assessmentOptionBlock = createAssessmentQuestionOption({});

    const [newBlocks] = flatten(assessmentOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createAssessmentQuestionInteractionBlock = (
  props,
  offset: number = 0
) => {
  return createBlock(
    'Interaction',
    [
      createAssessmentQuestion(),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'AssessmentQuestion',
        name: props.name,
        sId: getSId('interaction', offset),
        style: props.style || {},
      },
      meta: {
        subType: 'AssessmentQuestion',
      },
    }
  );
};

export const interactionConfig = {};
